﻿import { api } from '@cwd/lib/main';

export async function refreshTranslations(): Promise<void> {
    return api.post('/Localization/RefreshTranslations/', null);
}
